import { Handshake, Sword } from "lucide-react";
import { TRUST_COLOR, BETRAY_COLOR } from "../theme";

// `flip` mirrors the icon horizontally — used when this is the second icon
// in a pair, so a dagger points back toward the first icon (clashing inward)
// instead of off to the side.
function MoveIcon({ move, size = 20, strokeWidth = 2, color, flip = false }) {
  // lucide icons render as inline <svg> by default, which leaves a few
  // pixels of baseline whitespace below them — display:block keeps them
  // truly centered inside flex rows and absolutely-positioned badges.
  const style = { display: "block", transform: flip ? "scaleX(-1)" : "none" };
  const defaultColor = move === "cooperate" ? TRUST_COLOR : BETRAY_COLOR;
  const resolvedColor = color ?? defaultColor;
  if (move === "cooperate") {
    return <Handshake size={size} color={resolvedColor} strokeWidth={strokeWidth} style={style} />;
  }
  return <Sword size={size} color={resolvedColor} strokeWidth={strokeWidth} style={style} />;
}

export default MoveIcon;
